import { render, staticRenderFns } from "./appbar.vue?vue&type=template&id=63529632&scoped=true&lang=pug"
import script from "./appbar.vue?vue&type=script&lang=ts"
export * from "./appbar.vue?vue&type=script&lang=ts"
import style0 from "./appbar.vue?vue&type=style&index=0&id=63529632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63529632",
  null
  
)

export default component.exports